if (!customElements.get('multi-banner-slideshow')) {
  class MultiBannerSlideshow extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.touchStartX = 0;
    }

    connectedCallback() {
      this.track = this.querySelector('.multi-banner-hotspots__grid');
      this.slides = [...this.querySelectorAll('.multi-banner-hotspots__banner')];
      this.nav = this.querySelector('.slideshow-nav');

      if (!this.track || this.slides.length < 1) return;

      this.handleNavClick = this.handleNavClick.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.nav?.addEventListener('click', this.handleNavClick);
      this.track.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.track.addEventListener('touchend', this.handleTouchEnd, { passive: true });
      window.addEventListener('on:debounced-resize', this.handleResize);

      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.nav?.removeEventListener('click', this.handleNavClick);
      this.track?.removeEventListener('touchstart', this.handleTouchStart);
      this.track?.removeEventListener('touchend', this.handleTouchEnd);
      window.removeEventListener('on:debounced-resize', this.handleResize);
      clearTimeout(this.autoplayTimer);
    }

    get slidesPerPage() {
      if (!window.matchMedia('(min-width: 768px)').matches) return 1;
      return Math.max(parseInt(this.dataset.slidesPerPageDesktop, 10) || 1, 1);
    }

    get lastPageIndex() {
      return Math.max(this.slides.length - this.slidesPerPage, 0);
    }

    handleNavClick(event) {
      const button = event.target.closest('.slideshow-nav__btn');
      if (!button) return;
      button.name === 'next' ? this.next() : this.previous();
    }

    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
      clearTimeout(this.autoplayTimer);
    }

    handleTouchEnd(event) {
      const distance = event.changedTouches[0].screenX - this.touchStartX;
      if (Math.abs(distance) >= 50) {
        distance < 0 ? this.next() : this.previous();
      }
      this.startAutoplay();
    }

    handleResize() {
      this.currentIndex = Math.min(this.currentIndex, this.lastPageIndex);
      this.update(false);
    }

    next() {
      const nextIndex = this.currentIndex + this.slidesPerPage;
      this.currentIndex = nextIndex > this.lastPageIndex ? 0 : nextIndex;
      this.update();
      this.startAutoplay();
    }

    previous() {
      const previousIndex = this.currentIndex - this.slidesPerPage;
      this.currentIndex = previousIndex < 0 ? this.lastPageIndex : previousIndex;
      this.update();
      this.startAutoplay();
    }

    update(animate = true) {
      const target = this.slides[this.currentIndex];
      if (!target) return;

      this.track.scrollTo({
        left: target.offsetLeft,
        behavior: animate ? 'smooth' : 'instant'
      });

      this.slides.forEach((slide, index) => {
        const visible = index >= this.currentIndex && index < this.currentIndex + this.slidesPerPage;
        slide.classList.toggle('is-active', visible);
        slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        slide.tabIndex = visible ? 0 : -1;

        slide.querySelectorAll('a').forEach((link) => {
          link.tabIndex = visible ? 0 : -1;
        });
      });
    }

    startAutoplay() {
      clearTimeout(this.autoplayTimer);
      if (this.dataset.autoplay !== 'true' || this.slides.length <= this.slidesPerPage) return;

      const speed = Math.max(parseInt(this.dataset.speed, 10) || 7, 1) * 1000;
      this.autoplayTimer = setTimeout(() => this.next(), speed);
    }
  }

  customElements.define('multi-banner-slideshow', MultiBannerSlideshow);
}
